import { useContext, useState, useEffect } from "react";
import Button from "../../../elements/buttons/ButtonAction";
import ButtonAction from "../../../elements/buttons/ButtonAction";
import modalContext from "../../../../dataManager/context/modalContext";
import categoriesContext from "../../../../dataManager/context/categoriesContext";
import Input from "../../../elements/form/Input";
import InputFile from "../../../elements/form/InputFile";
import { checkFiels } from "../../../../functions/functions";
import { uploadImage } from "../../../../api/utils/";
import { updateCategoy } from "../../../../api/categories/categoriesApi";
import { toast } from "react-toastify";

const EditCategory = () => {
  //context variable
  const { onClose, modalParams } = useContext(modalContext);
  const { getOneCategory } = useContext(categoriesContext);

  // get the current selected category
  const category = getOneCategory(modalParams.categoryId);

  // init the form state
  const initFormData = {
    name: category.getName,
    starsNumber: category.getStarsNumber,
    image: category.getImage,
  };

  //state form variables
  const [formData, setFormData] = useState(initFormData);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  //firebase state variables
  const [imageUrl, setImageUrl] = useState("");
  const [progressLoadingImage, setProgressLoadingImage] = useState(0);
  const [isLoadingImage, setIsLoadingImage] = useState(false);

  //some handlers
  const handleChange = (e, inputTarget) => {
    setError("");
    switch (inputTarget) {
      case "name":
        return setFormData({ ...formData, name: e.target.value });
      case "starsNumber":
        return setFormData({ ...formData, starsNumber: e.target.value });
      case "image":
        return setFormData({ ...formData, image: e.target.files[0] });
      default:
        return;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    //check if the form is valid
    if (!checkFiels(formData)) {
      return setError("Veuillez remplir tous les champs");
    }

    //start loading
    setLoading(true);

    //edit category without changing the image
    if (formData.image === category.getImage) {
      return await editCategory(modalParams.categoryId, formData);
    }

    //upload new image on firebase before update the category
    uploadImage(
      "categories",
      formData.image,
      setImageUrl,
      setProgressLoadingImage,
      setIsLoadingImage
    );
  };

  //edit the category with the new image
  useEffect(() => {
    if (imageUrl) {
      console.log(modalParams.categoryId);
      console.log({
        ...formData,
        image: imageUrl,
      });
      editCategory(modalParams.categoryId, {
        ...formData,
        image: imageUrl,
      });
    }
  }, [imageUrl]);

  async function editCategory(idProduct, dataCategory) {
    //update the product
    const { data, error } = await updateCategoy(idProduct, dataCategory);

    if (error) {
      setError(error);
      return setLoading(false);
    }

    if (!data) {
      setError("Une erreur est survenue");
      return setLoading(false);
    }

    setLoading(false);
    toast.success("la catégorie à été modifié avec succes !", {
      theme: "colored",
    });
    onClose();
  }

  //destructuring the formData
  const { name, starsNumber, image } = formData;
  return (
    <form onSubmit={handleSubmit}>
      <div className="flex flex-col space-y-2">
        <InputFile
          labelName="Image de cette catégorie"
          name="image-category"
          onChange={(e) => handleChange(e, "image")}
        />
        <Input
          labelName="Nom catégorie"
          type="text"
          name="name"
          placeholder="desktop"
          value={name}
          onChange={(e) => handleChange(e, "name")}
        />
        <Input
          labelName="Nombre d'étoiles"
          type="number"
          name="startsNumber"
          placeholder="4"
          value={starsNumber}
          onChange={(e) => handleChange(e, "starsNumber")}
        />
      </div>
      <div className="mt-4 flex items-center space-x-2">
        <Button size="small" loading={loading}>
          Modifier
        </Button>
        <ButtonAction size="small" type="secondary" onClick={onClose}>
          Anuler
        </ButtonAction>
      </div>
      <span className="font-nunito text-sm text-[#fc3838]">
        {error && error}
      </span>
    </form>
  );
};

export default EditCategory;
